import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import SetListForm from "../../components/setList/SetListForm";
import { Button, Grid, Typography, FormControlLabel, Checkbox, TextField } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@material-ui/icons/Check";
import InputAdornment from "@material-ui/core/InputAdornment";
import blankProfile from "../../img/hotgig-loading.png";
import MainContainer from "../../components/MainContainer";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import Breadcrumb from "../../components/Breadcrumb";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor"
import "./Booking.css";
import moment from "moment";
import { Paper, Hidden } from "@material-ui/core";
import PdfViewer from "../../components/pdf/PdfViewer";
import MultiInputTextbox from './MultiInputTextbox';
import blankBackground from "../../img/hero2.jpg";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import BookingDetailsModal from "../../components/booking/DocumentModal/BookingDetailsModal.js";
import Heading from "../../components/Heading";
import MultiInputTextboxReplyTo from './MultiInputTextboxReplyTo';
import Loading from "../../components/loadingSpinner/Loading";
import SendBookingDetailsComponent from "./SendBookingDetailsComponent.js"
const BOOKING_STATUS = [
    "New",
    "Declined",
    "Negotiate",
    "Accepted",
    "LineupSet",
    "SetlistSet",
    "Ready",
    "Completed",
    "Paid",
    "Cancelled",
    "Resent",
    "Draft",
    "Incomplete",
    "Cancelled By Act",
    "Cancelled By Act",
    "SentToAct",
    "PlayerNotified",
    "PlayerDeclined",
    "AllPlayerConfirmed",
    "ClientNotified",
    "PlayerInvitedAndClientNotified",
    "PlayerConfirmedAndClientNotified"
];

@inject("templateStore", "bookingRequestStore", "profileStore", "userStore", "sendBookingDetailsStore")
@observer
class SendBookingDetails extends Component {
    state = {
        isLoading: false,
        clientMessage: "",
        pdfFile: "",
        to:[],
        image: null,
        openDetails: false,
        sendFeeDetails: true,
        replyTo:[],
        subject: ""
    };
    
    breadcrumb = [{ name: "Dashboard", link: "/" }, { name: "Send Booking Details" }];

    componentDidMount() {
        
    }
    render() {
        const { booking } = this.props.bookingRequestStore;
        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={this.breadcrumb} />
                    {/* <Heading title={bookingHeading}>
                        <div style={{ display: "inline-block" }}>
                            <BookingStatusBadge cancelledBy={booking.cancelledBy ? booking.cancelledBy.type : 0} status={this.getBookingStatus()} />
                        </div>
                    </Heading> */}
                    <Heading title={`${booking.title} - ${moment(booking.dateStart).format("ddd, DD-MM-YYYY")} - ${moment(booking.timeStart, "HH:mm").format("h.mma")}`}>
                    </Heading>
                  <SendBookingDetailsComponent bookingId={this.props.match.params.id} previousPage={this.props.match.params.previousPage}/>
                </MainContainer>
                
                
            </main>
        );
    }
}

export default SendBookingDetails;
